module.exports = __webpack_public_path__ + "static/media/AB_PW7_10.babc825d.jpg";